export const notficationredirection = (notificationType, userRole) => {
  const routeMappings = {
    'Job Assignment': {
      student: '/student/student/assigned/jobs',
      admin: '/admin/hr/view/admin/ready/students',
      superadmin: '/superadmin/job-assignments',
      placement: '/placement/hr/view/placement/ready/students',
    },
    'Fee Reminder': {
      student: '/student/fees/info',
      admin: '/admin/fee/details',
      superadmin: '/superadmin/fee/details',
      account: '/accountant/pay-fees',
    },
    'Test Assignment': {
      student: '/student/student/view/pending/tasks',
      teacher: '/teacher/tests',
      admin: '/admin/tests',
    },
    'Retest Assignment': {
      student: '/student/assigned/retest',
    },
    'Student Registration': {
      superadmin: '/superadmin/notification',
    },
    'Batch Assignment': {
      teacher: '/teacher/mark-attendance',
    },
    'Batch Swap': {
      student: '/student/profile',
      teacher: '/teacher/batches',
      admin: '/admin/batches',
    },
    'Installment Update': {
      student: '/student/fees/info',
      //   admin: '/admin/installments',
      //   account: '/account/installments',
    },
    'New Installment': {
      student: '/student/fees/info',
      //   admin: '/admin/installments',
      //   account: '/account/installments',
    },
    'Payment Confirmation': {
      student: '/student/fees/info',
      //   admin: '/admin/payments',
      //   account: '/account/payments',
    },
    'Salary Update': {
      teacher: '/teacher/salary/details',
      admin: '/admin/salary/details',
      account: '/accountant/salary/details',
      placement: '/placement/salary/details',
    },
    'Salary Payment': {
      teacher: '/teacher/salary/details',
      admin: '/admin/salary/details',
      account: '/accountant/salary/details',
      placement: '/placement/salary/details',
    },
    'Mock Test Marks': {
      student: '/student/view/mock/result',
    },
    'Mock Test Link': {
      student: '/student/view/mock/test/links',
    },
    Assignment: {
      student: '/student/assignments',
      teacher: '/teacher/assignments',
      admin: '/admin/assignments',
    },
    'Lecture Url Upload': {
      student: '/student/view/all/training/materials',
    },
    'Learning Material': {
      student: '/student/view/all/training/materials',
    },
    'Study Material': {
      student: '/student/view/all/training/materials',
    },
    'Training Material URL': {
      student: '/student/view/training-material-urls',
    },
    'Admin Registration': {
      superadmin: '/superadmin/view/admins',
    },
    'Unpause Placement Request': {
      superadmin: '/superadmin/pause/unpause/history',
      admin: '/admin/pause/unpause/history',
      placement: '/placement/view/all/paused/students',
    },
    'Placement Paused': {
      superadmin: '/superadmin/pause/students/placement',
      admin: '/admin/pause/students/placement',
      placement: '/placement/view/all/paused/students',
      student: '/student/assigned/paused-placements',
    },
    'Pdf Assignment': {
      student: '/student/submit/practicle/assignment',
    },
    'Practical Assignment': {
      student: '/student/submit/practicle/assignment',
    },
    'Practical Test': {
      student: '/student/practical/test',
      teacher: '/teacher/view/practical/tests',
    },
    'Drive Link Request': {
      teacher: '/teacher/view/practical/tests',
    },
  };

  return (
    routeMappings[notificationType]?.[userRole.toLowerCase()] ||
    `/${userRole.toLowerCase()}/`
  );
};

export const parseNotificationData = (data) => {
  if (!data) {
    return null;
  }

  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Failed to parse notification data:', error);
      return null;
    }
  }

  return data;
};

export const getNotificationNavigationTarget = (
  notificationType,
  userRole,
  data,
  hrRole
) => {
  const redirectPath = notficationredirection(notificationType, userRole);
  const parsedData = parseNotificationData(data);

  // These pages are list views and don't take an id in the URL
  if (
    notificationType === 'Placement Paused' ||
    notificationType === 'Unpause Placement Request'
  ) {
    // Head HRs and jr HRs use the /headhr layout
    if (
      userRole === 'placement' &&
      (hrRole === 'headhr' || hrRole === 'jrhr')
    ) {
      return redirectPath.replace(/^\/placement\//, '/headhr/');
    }
    return redirectPath;
  }

  if (parsedData?.releaseId) {
    const params = new URLSearchParams({
      releaseId: parsedData.releaseId,
    });

    return `${redirectPath}?${params.toString()}`;
  }

  if (parsedData?.materialId) {
    const params = new URLSearchParams({
      materialId: parsedData.materialId,
    });

    return `${redirectPath}?${params.toString()}`;
  }

  if (parsedData?.id) {
    return `${redirectPath}/${parsedData.id}`;
  }

  if (parsedData?.studentId) {
    return `${redirectPath}/${parsedData.studentId}`;
  }

  return redirectPath;
};
